

















import { Button } from 'element-ui'
import { Component, Vue } from 'vue-property-decorator'

import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

import { AuthActionTypes } from '@/store/modules/auth/actions'

@Component({
  components: {
    Footer,
    Header,
    [Button.name]: Button,
  },
  head: {
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  },
})
export default class WelcomeLayout extends Vue {
  get customerName(): string {
    const customer = this.$store.getters.getCurrentCustomer
    return customer ? `${customer.firstName}` : ''
  }

  skipPasswordChange() {
    this.$router.push({
      name: 'dashboard',
      query: { staff: 'true' },
    })
  }

  onLogout() {
    this.$store.dispatch(AuthActionTypes.Logout)
  }
}
